define('models/pages/wishlist/wishes/modal/index',['require','lib/utils','models/base/model','models/base/modal','./content'],function(require) {
    'use strict';

    var utils = require('lib/utils'),
        Model = require('models/base/model'),
        ModalModel = require('models/base/modal'),
        ContentModel = require('./content');


    var OrganizationModalModel = ModalModel.extend({
        defaults: {
            'title': 'Позиция листа ожиданий',
            'buttons': [
                { caption: 'Сохранить', className: 'btn-success', 'action': 'save' },
                { caption: 'Закрыть', className: '', 'action': 'cancel' }
            ],
            body: ''
        },
        constructor: function(data) {
            ModalModel.apply(this, arguments);
            this.content = new ContentModel(data);
        },
        dispose: function() {
            if (this.disposed) { return; }
            this.disposeSubModels();
            ModalModel.prototype.dispose.apply(this, arguments);
        },
        load: function() {
            var _this = this;
            _this.trigger('showPreloader');
            return this.content.load().then(function() {
                _this.trigger('hidePreloader');
            });
        }
    });

    return OrganizationModalModel;
});

